import * as React from "react";
import Box from "@mui/material/Box";

import "./style.css";

const CustomTooltip = (props) => {
    const { label, page } = props;

    return (
        <Box className="menu-item">
            <Box
                className="tooltip-data"
                sx={{
                    width: "70%",
                    minHeight: "80px",
                    marginTop: page === "Student" ? "-6px" : "0px",
                    p: 2,
                    backgroundColor: "white",
                    color: "black",
                    display: page === "Student" ? "" : "flex",
                    alignItems: page === "Student" ? "" : "center",
                }}>
                <span className="span">{label}</span>
            </Box>
            <Box className="tooltip-design" sx={{ minHeight: "100%" }}>
                <Box
                    sx={{
                        width: "45px",
                        height: "33%",
                        backgroundColor: "white",
                    }}></Box>
                <Box
                    sx={{
                        width: "30px",
                        height: "33%",
                        backgroundColor: "white",
                    }}></Box>
                <Box
                    sx={{
                        width: "15px",
                        height: "35%",
                        backgroundColor: "white",
                    }}></Box>
            </Box>
        </Box>
    );
};

export { CustomTooltip };
